export const listArt = [
  { name: 'Рубик', id: '9n7z' },
  { name: 'Шишка', id: 'rnvg' },
  { name: 'Магма', id: 'jkq7' },
  { name: 'Виток', id: '04yr' },
  { name: 'Юла', id: 'g34p' },
  { name: 'Статик', id: '4lpo' },
  { name: 'Тыква', id: 'qokj' },
  { name: 'Катушка', id: 'lj0j' },
  { name: 'Желе', id: '7z77' },
  { name: 'Петля', id: '6goy' },
  { name: 'Черная дыра', id: 'w4jo' },
  { name: 'Полено', id: 'zjzn' },
  { name: 'Личинка', id: 'yq3o' },
  { name: 'Харя', id: '51l0' },
  { name: 'Атом', id: 'wg53' },
  { name: 'Батарейка', id: 'zy32' },
  { name: 'Белая роза', id: 'wg62' },
  { name: 'Болотный гнилец', id: 'zyo9' },
  { name: 'Браслет', id: 'kqgy' },
  { name: 'Бубльгум', id: 'qodk' },
  { name: 'Ветка Калины', id: 'wglp' },
  { name: 'Вехотка', id: '9nvy' },
  { name: 'Висмут', id: '4lrn' },
  { name: 'Вихрь', id: 'y5k0' },
  { name: 'Волчьи слезы', id: 'y5nz' },
  { name: 'Гантель', id: 'y5yw' },
  { name: 'Гелий', id: 'kqr0' },
  { name: 'Гиря', id: 'y54z' },
  { name: 'Глаз бури', id: 'jkml' },
  { name: 'Гребешок', id: '4l7p' },
  { name: 'Дезинтегратор', id: 'wg3p' },
  { name: 'Ежик', id: 'zy7y' },
  { name: 'Ершик', id: 'gy06' },
  { name: 'Жабры', id: 'q1lk' },
  { name: 'Жар-птица', id: 'kqp0' },
  { name: 'Жвачка', id: 'qo59' },
  { name: 'Жильник', id: 'y5jk' },
  { name: 'Зеркало', id: 'zyrm' },
  { name: 'Змеиный глаз', id: '4lml' },
  { name: 'Золотистая Прима', id: 'zypm' },
  { name: 'Изюм', id: 'jky6' },
  { name: 'Иней', id: 'gyln' },
  { name: 'Каблук', id: 'kqoj' },
  { name: 'Канифоль', id: 'w4no' },
  { name: 'Кисель', id: 'zyv9' },
  { name: 'Кислотный кристалл', id: 'gyjg' },
  { name: 'Ключик', id: '5rm0' },
  { name: 'Комета', id: 'gyn0' },
  { name: 'Корка', id: '5rzo' },
  { name: 'Красный кристалл', id: 'gy10' },
  { name: 'Креветка', id: 'gyg5' },
  { name: 'Криоген', id: 'y5m3' },
  { name: 'Кристалл Изнанки', id: '1kw1' },
  { name: 'Куриный бог', id: 'qo94' },
  { name: 'Лампочка Ильича', id: '4lkp' },
  { name: 'Ледяной ежик', id: '5r5g' },
  { name: 'Липкий репях', id: '1kdg' },
  { name: 'Многогранник', id: 'ljpq' },
  { name: 'Морозец', id: 'ljn2' },
  { name: 'Нервяк', id: '49zn' },
  { name: 'Обруч', id: 'k3yv' },
  { name: 'Огонек', id: 'zyw2' },
  { name: 'Осколок', id: '5rwq' },
  { name: 'Остов', id: 'wgzd' },
  { name: 'Пиявка', id: '5rog' },
  { name: 'Плод', id: 'gypg' },
  { name: 'Призма', id: 'y5w3' },
  { name: 'Призрачный кристалл', id: '9nd0' },
  { name: 'Прима', id: '1kv2' },
  { name: 'Проклятая роза', id: '5rg1' },
  { name: 'Протоцибуля', id: '4l1r' },
  { name: 'Радиатор', id: 'ljrj' },
  { name: 'Репях', id: '9nml' },
  { name: 'Роза', id: 'gyv6' },
  { name: 'Роза Изнанки', id: 'wgko' },
  { name: 'Ряска', id: 'jkj4' },
  { name: 'Сало', id: '1k4q' },
  { name: 'Сердце', id: '5r34' },
  { name: 'Сетчатка', id: 'gy7p' },
  { name: 'Скорлупа', id: 'y5vw' },
  { name: 'Смалец', id: 'zymn' },
  { name: 'Смольник', id: 'j3p6' },
  { name: 'Солнце', id: 'qoq6' },
  { name: 'Спираль', id: 'gyq5' },
  { name: 'Стальной Ежик', id: '5rd1' },
  { name: 'Темная калина', id: 'kq4v' },
  { name: 'Темный кристалл', id: 'wgr3' },
  { name: 'Трансформатор', id: 'qo06' },
  { name: 'Трещотка', id: '1k96' },
  { name: 'Улитка', id: 'kqj3' },
  { name: 'Фаренгейт', id: 'wgwz' },
  { name: 'Флегма', id: '5r04' },
  { name: 'Хрусталь', id: 'zyqk' },
  { name: 'Цибуля', id: 'zyly' },
  { name: 'Чернильница', id: 'wgvd' },
  { name: 'Ягодка', id: '9n1w' },
  { name: 'Яйцо', id: 'y5ro' },
  { name: 'Янтарник', id: '5rpq' },
  { name: 'Опал', id: 'rn1z' }
]

export const QUALITY_LIST = [
  {
    value: 0,
    label: 'Обычный',
    labelEn: 'Common',
    color: '#A0A0A0',
    bgColor: 'rgba(128, 128, 128, 0.2)',
    borderColor: '#7C7CFF'
  },
  {
    value: 1,
    label: 'Необычный',
    labelEn: 'Uncommon',
    color: '#90EE90',
    bgColor: 'rgba(144, 238, 144, 0.2)',
    borderColor: '#90EE90'
  },
  {
    value: 2,
    label: 'Особый',
    labelEn: 'Special',
    color: '#87CEEB',
    bgColor: 'rgba(135, 206, 235, 0.2)',
    borderColor: '#87CEEB'
  },
  {
    value: 3,
    label: 'Редкий',
    labelEn: 'Rare',
    color: '#DDA0DD',
    bgColor: 'rgba(147, 112, 219, 0.2)',
    borderColor: '#DDA0DD'
  },
  {
    value: 4,
    label: 'Исключительный',
    labelEn: 'Exceptional',
    color: '#DC143C',
    bgColor: 'rgba(220, 20, 60, 0.2)',
    borderColor: '#DC143C'
  },
  {
    value: 5,
    label: 'Легендарный',
    labelEn: 'Legendary',
    color: '#FFD700',
    bgColor: 'rgba(255, 215, 0, 0.2)',
    borderColor: '#FFD700'
  }
]

export const SHARPENING_LIST = [
  { label: '0-4', value: 0, color: '#6c757d' },
  { label: '5-9', value: 5, color: '#28a745' },
  { label: '10-14', value: 10, color: '#007bff' },
  { label: '15', value: 15, color: '#dc3545' }
]

export function getNameArtFromId(id: string) {
  return listArt.find(item => item.id === id)?.name ?? 'not found'
}

export function normalizeReturnPtn(ptn: number): string {
  if (ptn === 0) return '0-4'
  if (ptn === 5) return '5-9'
  if (ptn === 10) return '10-14'
  if (ptn === 15) return '15'
  return 'unknown'
}
